import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { Link } from 'react-router';
import routes from 'routes';
import { Search_searchCampaigns } from 'types/apollo/Search';
import { StatusChip } from '../status-chip';

interface CampaignSearchMetaProps {
  campaigns: Search_searchCampaigns[];
}

export const CampaignSearchMeta: FC<CampaignSearchMetaProps> = ({ campaigns }) => {
  return (
    <Card variant="outlined">
      <Box px={2} pt={2}>
        <Typography variant="h5">Campaigns</Typography>
      </Box>
      <Stack divider={<Divider />} component={List}>
        {campaigns.length === 0 && (
          <ListItem>
            <ListItemText primary="No Campaigns Found" />
          </ListItem>
        )}
        {campaigns.map((campaign) => {
          const campaignName = (
            <>
              <b>{campaign.id}</b> {campaign.name}
            </>
          );
          const styles = campaign.exactMatch ? { backgroundColor: '#e2ffe2' } : {};
          return (
            <ListItemButton
              key={`${campaign.id}-${campaign.name}`}
              component={Link}
              to={routes.company.campaign.resolve({
                id: campaign.companyId.toString(),
                campaignId: campaign.shortId,
              })}
              sx={styles}
            >
              <ListItemText
                primary={campaignName}
                secondary={`${campaign.companyName} / ${campaign.brandName}`}
              />
              <StatusChip status={campaign.status} activeStatus={campaign.status} />
            </ListItemButton>
          );
        })}
      </Stack>
    </Card>
  );
};
